import React 		from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';

import FloatingImage from './_FloatingImage.jsx';
import {AwardIcon}		from './_Icons.jsx';
import {StudioAwards}		from '../studio/_StudioAwards.jsx';

export default class SimpleProfileCard extends BLComponent {

	constructor(props, context) {
		super(props, context);

		this.state = {
			
		}
	}

	render() {
		var {classes = '', user, type} = this.props;
		let badges = this.props.awards;
		let me = blapp.session.getMe();

		if(user == null && me !== null) {
			user = me;
		}
		
		const country = blapp.country.get(user.codeCountry);
		const state 	= blapp.country.getStateLegacy(user.idState);

		let extraFlag = country.codeCountry == 'UK' && state;
		//const selectedAward = StudioAwards(award);

		let awards = [];

		badges && badges.length > 0 && badges.forEach(badge => {
			awards.push(<AwardIcon source={'card'} award={badge} background tooltipClass={'award-icon-tooltip--profile'}/>)
		})

		return (
			<article className={"simple-profile-card " + classes}>
				<div className="simple-profile-card__image" data-ts-name="simple-profile-card__image">
					<img className="simple-profile-card__image-item" src={blapp.url2.getProfileImgUrl(user,'large')} onError={(e) => e.target.src = blapp.session.getMyProfileURL('medium')}/>
				</div>
				<div className="simple-profile-card__details">
					{type == 'title' ? <h2 className="simple-profile-card__name page-title" data-ts-name="simple-profile-card__name">{user.skUsername}</h2> : <strong className="simple-profile-card__name" data-ts-name="simple-profile-card__name">{user.skUsername}</strong>}
					<div className="simple-profile-card__location" data-ts-name="simple-profile-card__location">
						{extraFlag ? <img className="simple-profile-card__flag" src={blapp.url.getCountryFlagSmallURL(state.idStateLegacy)}/> : null}
						<img className="simple-profile-card__flag" src={blapp.url.getCountryFlagSmallURL(country.codeCountry)}/>
						<p>{state != null ? `${state.strStateName}, ` : null}{country.strCountryName}</p>
					</div>
					{awards.length > 0 && 
						<div className="l-flex l-center simple-profile-card__award" data-ts-name="simple-profile-card__award">
							{awards}
						</div>
					}
				</div>
			</article>
		);
	}
	
};


SimpleProfileCard.propTypes = {
		classes: PropTypes.string
	,	user: PropTypes.object
	, type: PropTypes.string
}